import { type FlowCreatePatientOrderBlock, FlowCreatePatientOrderConfigSchema } from 'flow-schema';

import { CreatePatientOrderFormFields } from './FormFields';
import { CreatePatientOrderDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const createPatientOrderConfig: BlockConfigProps<FlowCreatePatientOrderBlock['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'createPatientOrder',
  defaultConfig: {
    payload: '',
  },
  configFields: {
    schema: FlowCreatePatientOrderConfigSchema,
    FormFields: CreatePatientOrderFormFields,
  },
  documentationMarkdown: CreatePatientOrderDocumentationMarkdown,
};
